/*
export const someMutation = (state) => {}
 */
import { initialState } from './state'
export default {
  isLoading,
  doneLoading,
  setList,
  updateRejectionNotes,
  clearRejectionNotes,
  resetState,
  setInstructorSearch,
  setClassAffiliateSearch,
  resetClassSearchFields
}

function isLoading (state) {
  state.loadingData = true
}

function doneLoading (state) {
  state.loadingData = false
}
function setList (state, { approvals }) {
  state.list = approvals
}

function setInstructorSearch (state, payload){
  state.classSearchFields['~INSTRUCTOR_ID'] = payload ? payload.item.INSTRUCTOR_ID : null
}

function setClassAffiliateSearch (state, payload){
  state.classSearchFields['~CLASS.AFFILIATE_ID'] = payload ? payload.item.AFFILIATE_ID : null
}

function resetClassSearchFields(state){
  state.classSearchFields = _.cloneDeep(initialState.classSearchFields)
}

function updateRejectionNotes (state, val){
  state.rejectionNotes = val
}

function clearRejectionNotes (state) {
  state.rejectionNotes = ''
}

function resetState (state) {
  // _.each(state, (value, key) => {
  //   state[key] = initialState[key]
  // })
  state = { ...initialState }
}
